module.exports = __webpack_public_path__ + "img/116.e9551659.jpg";